import {Column, Entity, OneToOne, PrimaryGeneratedColumn} from "typeorm"
import { Tele2Details } from "./Tele2Details"

export enum RemoteSocketHistoryType {
  Requested = "REQUESTED",
  Received = "RECEIVED",
  PowerOff = "POWEROFF",
  PowerOn = "POWERON",
}

export interface RemoteSocketReading {
  timestamp: Date,
  state: boolean,
  type: RemoteSocketHistoryType
}

export enum RemoteSocketState {
  On = "ON",
  Off = "OFF",
  Unknown = "UNKNOWN"
}

@Entity()
export class RemoteSocket {

	@PrimaryGeneratedColumn()
  id?: number
  
  @Column()
  state!: RemoteSocketState

  @Column()
  pending_state!: RemoteSocketState

  @Column({ type: 'json' }) 
  history!: RemoteSocketReading[]
	
  @OneToOne(() => Tele2Details, (s) => s.remote_socket)
  sim!: Tele2Details
}